import { useEffect, useCallback } from "react";

// reducers
import { useStore } from 'react-redux';
import { useSelector } from 'react-redux';
import { selectDistribution, updateDistribution } from 'hyc-store/reducers/distribution';
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';

// components
import { SelectMonth } from 'shared/components';
import { SelectYear } from 'shared/components';
import { ModalShipment } from './modal-shipment';
import { ShipmentCards } from './shipment-cards';
import { Button } from 'shared/components/bulma/button';

// functions
import { useToggle } from 'shared/functions';

import * as helper from '../helper';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const ShipmentTile = () => {
    const store = useStore();
    const country = useSelector(selectCountry);
    const { month, year, data, today } = useSelector(selectDistribution);

    const [modal, setModal] = useToggle(false);
    const [sameMonth, setSameMonth] = useToggle(false);


    const handlePickOption = (option) => {
        store.dispatch(updateDistribution({ month: option }));
        setSameMonth(false);
    }

    const handleYear = (event) => {
        store.dispatch(updateDistribution({ year: event.target.value }));
        setSameMonth(false);
    }


    const getData = useCallback(async () => {
        const data = await helper.getData(year, month, country);
        store.dispatch(updateDistribution({
            data
        }));

    }, [month, country, year, store]);

    useEffect(() => {
        if (month === null) {
            const todayDate = new Date(today);
            store.dispatch(updateDistribution({
                year: todayDate.getFullYear(),
                month: MONTHS[todayDate.getMonth()]
            }));
        };
        getData();

    }, [year, month, sameMonth, today, store, getData]);

    if (!month) { return null; }

    return (
        <section className="section is-small p-0 m-0">

            <div className="tile is-ancestor">

                <div className="tile">
                    <div className="tile is-parent is-vertical">
                        <article className="tile is-primary is-light is-12 is-child notification">
                            <div className="mb-3">
                                <div className="columns">

                                    <div className="column is-10">
                                        <p className="title">Shipment Dates</p>
                                    </div>

                                    <div className="column is-2">
                                        <p><strong><Button onClick={setModal} className="is-primary ">Create New Dates</Button></strong></p>
                                    </div>

                                </div>
                            </div>
                            <div className="columns is-vcentered">
                                <div className="column is-1">
                                    <SelectYear onChange={handleYear} year={year} />
                                </div>
                                <div className="column is-1">
                                    <SelectMonth onChange={handlePickOption} month={month} months={MONTHS} />
                                </div>
                            </div>

                            <div className="content">

                                <div className="columns is-12 is-multiline">
                                    <ShipmentCards data={data} onChange={setModal} />
                                </div>

                            </div>
                        </article>

                    </div>

                </div>
            </div >

            {/* Shipment Modal */}
            <ModalShipment modal={modal} handleModal={setModal} />
        </section>
    )

}

export { ShipmentTile };
